// extracted by mini-css-extract-plugin
module.exports = {"card":"EventCard_card__2JRjA"};